import $ from 'jquery'; // TODO purge
// import {globalUpdate} from '../shoptools/index';
import {post} from '../shoptools/fetch';
import {updateCart} from '../shoptools/index';

require('imports-loader?define=>false!../lib/jquery.form.js')($);

export function accountUpdate () {
  const html = document.documentElement
  const cartWrap = html.querySelector('.cart-summary-wrap')

  if (cartWrap) {
    $.get(cartWrap.getAttribute('data-cart-url'), function (data) {
      if (data.cart) {
        updateCart(data.cart);
      }

      // $('body').toggleClass('age-not-verified', !data.age_verified);
    });
  }
}

export function shippingSelector(container) {
  const forms = container.querySelectorAll('form.shipping-option-selector')
  forms.forEach((form) => {
    form.querySelector('select').addEventListener('change', () => {
      form.submit()
    })
  })
}

export function purchaseForm(form, layoutCallback) {
  const $form = $(form)

  $form.ajaxForm({
    beforeSubmit: function () {
      const url = $form.attr('action');
      const data = $form.serialize();

      if ($form.find('input[name="pk"]').val() == '') return false;

      // let valid = true;
      // $form.find('.option-selector select')

      post(url, data).then((response) => {
        return response.json();
      }).then((data) => {
        if (data.success) {
          form.classList.add('added', 'show-checkout')
          form.classList.remove('error')
          // document.querySelector('.cart-link').classList.add('product-added')

          if (data.cart) {
            updateCart(Object.assign(data.cart, {'html_snippet': data.html_snippet}));
          }

          setTimeout(() => {
              form.classList.remove("added");
            }, 5000);

          // globalUpdate(data);
        } else {
          form.querySelector('.errors').innerHTML = data.errors.join('<br>');
          form.classList.add('error');
          form.classList.remove('added')
        }
        if (layoutCallback) layoutCallback();
      });

      return false;
    }
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/cart.js